import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { DecisivePlayerPickerTaskRow } from '#src/components/missions/PlayTask/DecisivePlayerPickerTaskRow/index.tsx';
import { GenericTaskRow } from '#src/components/missions/PlayTask/GenericTaskRow/index.tsx';

import type { PlayMissionsTaskRow_taskInterface } from './__generated__/index.graphql.ts';

export const PlayMissionsTaskRow = ({
  task,
  onClaim,
  loading,
}: {
  task: PlayMissionsTaskRow_taskInterface;
  onClaim?: () => void;
  loading?: boolean;
}) => {
  if (isType(task, 'DecisivePlayerPickerTask')) {
    return <DecisivePlayerPickerTaskRow task={task} />;
  }
  if (isType(task, 'Task')) {
    return <GenericTaskRow task={task} onClaim={onClaim} loading={loading} />;
  }
  return null;
};

PlayMissionsTaskRow.fragments = {
  taskInterface: gql`
    fragment PlayMissionsTaskRow_taskInterface on TaskInterface {
      id
      ... on DecisivePlayerPickerTask {
        id
        ...DecisivePlayerPickerTaskRow_decisivePlayerPickerTask
      }
      ... on Task {
        id
        ...GenericTaskRow_taskInterface
      }
    }
    ${DecisivePlayerPickerTaskRow.fragments.decisivePlayerPickerTask}
    ${GenericTaskRow.fragments.taskInterface}
  ` as TypedDocumentNode<PlayMissionsTaskRow_taskInterface>,
};
